import { Injectable } from '@angular/core';
import { CommandService } from './command.service';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class StockService extends CommandService {
  constructor() {
    super(new ToastController());
  }

  sendMessage() {
    this.cmd = '3A26';

    this.ble
      .writeWithoutResponse(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.txUUID,
        this.hexTobytes(this.cmd)
      )
      .then(
        (data) => {
          console.log('Result Write : ', data);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public receiveResponse(data: any) {
    console.log('response stock');
    console.log(this.buf2hex(data).toLowerCase());
    if (this.buf2hex(data).toLowerCase() == '3a01') {
      return true;
    }
    return false;
  }
}
